import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'content')


	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "clQ060PJoN",
			"left": 457.48,
			"top": 127.97999999999999,
			"width": 501.5599999999999,
			"height": 140,
			"content": `<p style=\"\"><strong><span style=\"font-size: 80px;\">${serial}</span></strong></p>`,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"vertical": false
		},
		{
			"type": "text",
			"id": "NcCyUVEGl9",
			"left": 457.48,
			"top": 256.25,
			"width": 519.831223628692,
			"height": 50,
			"content": `<div>${title}</div>`,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"vertical": false
		}
		],
		background
	};

}